import { Component, inject } from '@angular/core';
import { ToastController } from '../../../infrastructure/real/global/toast-controller-repository';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [IconComponent],
  template: `
    <div class="toast-host">
      @for (toast of toastController.toasts(); track toast.id) {
        <div class="toast elev-md" [class]="'toast-' + toast.kind" role="status">
          <span class="toast-icon">
            <app-icon [name]="toast.kind === 'success' ? 'check' : 'info'" [size]="16" />
          </span>
          <span class="toast-message">{{ toast.message }}</span>
          <button type="button" class="toast-close" (click)="toastController.dismiss(toast.id)">
            ×
          </button>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toast-host {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 200;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        pointer-events: none;
      }

      .toast {
        pointer-events: auto;
        display: flex;
        align-items: center;
        gap: 12px;
        max-width: min(520px, 92vw);
        min-width: min(320px, 92vw);
        padding: 12px 14px 12px 12px;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.45;
        border: 1px solid transparent;
        border-left-width: 4px;
        border-radius: var(--radius-sm);
        background: var(--color-surface);
        box-shadow: var(--shadow-lg);
      }

      .toast-icon {
        width: 30px;
        height: 30px;
        flex: none;
        display: grid;
        place-items: center;
        border-radius: 50%;
      }

      .toast-message {
        flex: 1;
      }

      .toast-success {
        color: var(--color-success-text);
        border-color: var(--color-success-text);
      }

      .toast-success .toast-icon {
        background: var(--color-success-bg);
      }

      .toast-error {
        color: var(--color-danger-text);
        border-color: var(--color-danger-text);
      }

      .toast-error .toast-icon {
        background: var(--color-danger-bg);
      }

      .toast-info {
        color: var(--color-accent-800);
        border-color: var(--color-accent-300);
      }

      .toast-info .toast-icon {
        background: var(--color-accent-100);
      }

      .toast-close {
        border: 0;
        background: transparent;
        color: inherit;
        cursor: pointer;
        width: 24px;
        height: 24px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        font-size: 18px;
        line-height: 1;
        padding: 0 2px;
      }

      .toast-close:hover {
        background: color-mix(in srgb, currentColor 10%, transparent);
      }
    `,
  ],
})
export class ToastHostComponent {
  readonly toastController = inject(ToastController);
}
